module.exports = __webpack_public_path__ + "img/prize-02.3859601c.png";